export const EventTypes: Record<string, string> = {
  REMOVE: "securityDataMessageDelete",
  PAY: "securityDataMessage",
};

export enum EventTypeEnum {
  REMOVE = "REMOVE",
  PAY = "PAY",
}
